import { RadioButtonsGroup, SpacingVertical } from "mailup-web-components";
import React, { type FC, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import FileList from "./FileList";
import FileUploader from "./FileUploader";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  importTypeState,
  tableState,
} from "Pages/ImportWizard/recoil/state/stateStep1";
import { gainsightTrack } from "mailup-react-helpers";

const UploadFile: FC = () => {
  const intl = useIntl();
  const [importType, setImportTypeState] = useRecoilState(importTypeState);
  const { items } = useRecoilValue(tableState);

  useEffect(() => {
    gainsightTrack("mup_importWizard_visitFirstStep", {});
  }, []);

  const onChangeMode = () => {
    if (importType === "list") {
      gainsightTrack("mup_importWizard_clickFileUploadSelector", {});
    } else {
      gainsightTrack("mup_importWizard_clickSelectAFileInDialogBox", {});
    }

    setImportTypeState(importType === "file" ? "list" : "file");
  };
  return (
    <>
      <RadioButtonsGroup
        onChange={onChangeMode}
        items={[
          {
            label: intl.formatMessage({ id: "Load.FileImport.UploadFile" }),
            value: "file",
          },
          {
            label: intl.formatMessage({ id: "Load.FileImport.SelectFile" }),
            value: "list",
            disabled: items.length === 0,
          },
        ]}
        value={importType}
      />
      <SpacingVertical />
      {importType === "file" && <FileUploader />}
      {importType === "list" && <FileList />}
    </>
  );
};
export default UploadFile;
